<form (ngSubmit)="loadShipment()" autocomplete="off">
    <mat-form-field appearance="fill" style="width:100%;">
        <mat-label>Shipment Number</mat-label>
        <input #shipmentNbrField matInput [formControl]="shipmentNbrCtl" name="shipmentNbr" [scanInput] [autofocus]
            required (scanned)="loadShipment()" />
        <button type="button" mat-icon-button matSuffix *ngIf="shipmentNbrField.value"
            (click)="shipmentNbrField.value = ''">
            <mat-icon>cancel</mat-icon>
        </button>
    </mat-form-field>
</form>